module.exports = __webpack_public_path__ + "img/spaghetti-soia.c8665ae2.png";